import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=f3021da2&scoped=true"
import script from "./fault.vue?vue&type=script&lang=js"
export * from "./fault.vue?vue&type=script&lang=js"
import style0 from "./fault.vue?vue&type=style&index=0&id=f3021da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3021da2",
  null
  
)

export default component.exports